<script setup lang="ts">
const imageLoaded = ref(false)

defineOptions({
  name: 'IntroComponent'
})

const { elementReference, isReady, isRevealed } = useScrollReveal()
</script>

<template>
  <div
    ref="elementReference"
    :class="['px-0 py-0 mx-0 my-0', { reveal: isReady, revealed: isRevealed }]"
  >
    <div class="pt-high">
      <v-row align="center">
        <v-col cols="12" lg="6" class="pb-8 pb-lg-0">
          <NuxtImg
            :class="imageLoaded ? 'image-visible w-100' : 'image-invisible w-100'"
            src="/images/stock_team.webp"
            alt="Andreas Szklarek"
            @load="imageLoaded = true"
          />
        </v-col>
        <v-col cols="12" lg="6" class="px-8 px-lg-16">
          <h1 class="text-primary bannerTitle font-weight-regular mb-8">Leistungen</h1>
          <h2 class="text-h3 font-weight-regular mb-3">
            Wir realisieren Gebäude für Produzierende, Entwickler und Investoren.
          </h2>
          <p class="text-body-1 mb-4">
            Unser Unternehmen hat sich auf den Fertigbau spezialisiert. Als Baumanager/Generalist
            setzen wir Projekte im Neubau- wie im Umbaubereich für Sie um. Wir realisieren Gebäude,
            berechnen die Statik, planen die Gebäudetechnik und bauen ihre Außenanlagen. Unsere
            Konzepte sind auf System-, Modul- oder Holztafelbau ausgelegt aber auch auf
            Hybridbauweise oder konventionell in Stein auf Stein und Beton. Als erfahrenes
            Unternehmen sind wir schnell, kosteneffizient und unkompliziert. Ganz nach dem Motto
            „just do it“.
          </p>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<style scoped lang="scss">
.image-invisible {
  opacity: 1;
}

.image-visible {
  opacity: 1;
  transition: opacity 3.5s;
}
</style>
